import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=ed73cc0e&"
import script from "./EntityView.vue?vue&type=script&lang=js&"
export * from "./EntityView.vue?vue&type=script&lang=js&"
import style0 from "./EntityView.vue?vue&type=style&index=0&id=ed73cc0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports